// Story 11.4 — DevModeInfo dialog: placebo. El dev mode real vive en CLI
// (Story 6.3). El editor web informa al user con copy + button Copy.

import { Copy } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Modal } from './Modal';

interface Props {
  open: boolean;
  onClose: () => void;
  botName?: string;
}

export function DevModeInfoDialog({ open, onClose, botName }: Props): React.ReactElement {
  const command = `revel-bots dev --bot ${botName ?? '<bot-name>'}`;
  const [copied, setCopied] = useState(false);

  async function handleCopy(): Promise<void> {
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(command);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Dev Mode"
      description="El dev mode (file-watch + WhatsApp test loop) se lanza desde la CLI."
      footer={
        <Button variant="default" onClick={onClose}>
          Entendido
        </Button>
      }
    >
      <div className="space-y-3">
        <p className="text-sm text-muted-foreground">
          Copia este comando y ejecútalo en tu terminal (con el repo del bot abierto):
        </p>
        <pre className="overflow-x-auto rounded-md border border-border bg-muted/40 p-3 font-mono text-xs">
          <code>{command}</code>
        </pre>
        <div className="flex justify-end">
          <Button variant="outline" onClick={handleCopy}>
            <Copy className="h-4 w-4" />
            {copied ? 'Copiado' : 'Copiar comando'}
          </Button>
        </div>
        <p className="text-[11px] text-muted-foreground">
          Una vez que el dev mode esté corriendo, el LogPanel del editor recibirá los eventos en
          vivo (WS) y el badge del bot pulseará en verde.
        </p>
      </div>
    </Modal>
  );
}
